import { useQuery } from 'react-query';

import type { GetNotificationsParams } from '~/api/data-source/notification';
import { NOTIFICATION_QUERY_KEY } from '~/api/query-keys/notification';

// Re-export types for convenience
// Params 타입
export type { GetNotificationsParams } from '~/api/data-source/notification';

// Response 타입 (Model)
export type {
  CampaignNotification,
  CampaignProductItem,
  NotificationCategory,
  NotificationItem,
  NotificationList,
  NotificationQuoteType,
  NotificationServiceType,
  QuoteDisplayStatus,
  QuoteNotification,
} from '~/api/model/notifications';

// ============================================================================
// Query 훅
// ============================================================================

/** 알림 목록 조회 */
// GET /api/market-place/notifications
export const useNotifications = (
  category: GetNotificationsParams['category'],
) => {
  const { queryKey, queryFn } = NOTIFICATION_QUERY_KEY.all(category);

  return useQuery(queryKey, queryFn, {
    suspense: true,
  });
};
